export const DepositTableHelpers = {
  data() {
    return {
      tableColumns: [
        {
          title: 'Expediente',
          type: 'custom-html',
          key: 'accreditation_application',
          modifier: (item) => {
            return `<a href="/accreditations/applications/${item.id}" target="_blank">${item.record || ''}</a>`;
          }
        },
        {
          title: 'OEC',
          type: 'custom-html',
          key: 'accreditation_application',
          modifier: (value) => {
            if (value.organization) {
              return value.organization.business_name;
            } else {
              return 'N/A';
            }
          }
        },
        {
          title: 'Comprobante',
          type: 'text',
          key: 'number',
        },
        {
          title: 'Monto',
          type: 'custom-html',
          key: 'amount',
          modifier: (value) => {
            if (value) {
              return value.toFixed(2).replace(/(\d)(?=(\d{3})+(?:\.\d+)?$)/g, "$1,")
            } else {
              return 'N/A';
            }
          }
        },
        {
          title: 'Fecha Pago',
          type: 'custom-html',
          key: 'date',
          modifier: (value) => {
            if (value) {
              return moment(value).format("YYYY-MM-DD");
            }
          }
        },
        {
          title: 'Tipo',
          type: 'custom-html',
          key: 'type',
          modifier: (value) => {
            let type = 'OTRO';
            if (value === 'S') {
              type = 'SOLICITUD ';
            } else if (value === 'P') {
              type = 'PROFORMA';
            }
            return type;
          }
        },
        {
          title: 'Pago de',
          type: 'custom-html',
          key: 'eval_test',
          modifier: (value) => {
            let type = '';
            if (value) {
              if (value.type == 'E') {
                type = 'Evaluación';
              } else {
                type = 'Testificación';
              }
            } else {
              type = 'Acreditación';
            }
            return type;
          }
        },
        {
          title: 'Convenio',
          type: 'custom-html',
          key: 'is_agreement',
          modifier: (value) => {
            let type = 'NO';
            if (value) {
              type = 'SI ';
            }
            return type;
          }
        },
        {
          title: 'Convenio Aprobado Por',
          type: 'custom-html',
          key: 'is_agreement',
          modifier: (value, row) => {
            let user;
            if (value) {
              if (row.eval_test && row.eval_test.agreement_approved_by) {
                user = row.eval_test.agreement_approved_by.user;
              } else if (row.accreditation_application.agreement_approved_by) {
                user = row.accreditation_application.agreement_approved_by.user;
              }
            }
            return user ? `${user.first_name} ${user.last_name}` : null;
          }
        },
        {
          title: 'Estado',
          type: 'custom-html',
          key: 'is_approved',
          modifier: (value) => {
            if (value) {
              let ClassName = 'warning';
              let state = 'Pendiente';
              if (value === 3) ClassName = `danger`, state = 'Rechazado';
              return `<span class="badge badge-sm badge-pill badge-${ClassName}">${state}</span>`;
            }
          }
        },
        {
          title: 'Días Disponibles',
          type: 'custom-html',
          key: 'accreditation_application',
          modifier: (value, row) => {
            let tmp;
            if (row.eval_test) {
              if (row.eval_test.eval_test_time) {
                if (row.eval_test.eval_test_time.remaining_days > 1) {
                  tmp = `<span class="badge badge-sm badge-pill badge-success">${row.eval_test.eval_test_time.remaining_days}</span>`;
                }
                if (row.eval_test.eval_test_time.remaining_days == 1) {
                  tmp = `<span class="badge badge-sm badge-pill badge-warning">${row.eval_test.eval_test_time.remaining_days}</span>`;
                }
                if (row.eval_test.eval_test_time.remaining_days == 0) {
                  tmp = `<span class="badge badge-sm badge-pill badge-danger">${row.eval_test.eval_test_time.remaining_days}</span>`;
                }
              }
              return tmp;
            } else {
              if (value.accreditation_time) {
                if (value.accreditation_time.remaining_days > 1) {
                  tmp = `<span class="badge badge-sm badge-pill badge-success">${value.accreditation_time.remaining_days}</span>`;
                }
                if (value.accreditation_time.remaining_days == 1) {
                  tmp = `<span class="badge badge-sm badge-pill badge-warning">${value.accreditation_time.remaining_days}</span>`;
                }
                if (value.accreditation_time.remaining_days == 0) {
                  tmp = `<span class="badge badge-sm badge-pill badge-danger">${value.accreditation_time.remaining_days}</span>`;
                }
              }
              return tmp;
            }
          }
        },
        {
          title: 'Agrupado',
          type: 'custom-html',
          key: 'eval_test',
          modifier: (item) => {
            if (item) {
              if (item.key_combo) {
                return `<span class="badge badge-sm badge-pill badge-primary">Por ${item.key_combo}</span>`;
              } else {
                return 'N/A';
              }
            } else {
              return 'N/A';
            }
          }
        },
      ],
      actionObj: {
        title: 'Acciones',
        type: 'action',
      }
    }
  },
}